export const cn = {
    title: '解锁成功！🎉',
    subtitle: '感谢您的订阅。',
    continueButton: '继续与 Eureka 对话',
    receiptSent: '收据已发送至您的邮箱：{email}',
}
export const en = {
    title: 'Unlock Successful! 🎉',
    subtitle: 'Thank you for subscribing.',
    continueButton: 'Continue chatting with Eureka',
    receiptSent: 'A receipt has been sent to your email: {email}',
}
export const tw = {
    title: '解鎖成功！🎉',
    subtitle: '感謝您的訂閱。',
    continueButton: '繼續與 Eureka 對話',
    receiptSent: '收據已發送至您的郵箱：{email}',
}
export const jp = {
    title: 'アンロック成��！🎉',
    subtitle: 'ご登録ありがとうございます。',
    continueButton: 'Eureka とのチャットを続ける',
    receiptSent: '領収書がメールに送信されました：{email}',
}
